import VAvatar from './VAvatar'

/* istanbul ignore next */
VAvatar.install = function install (Vue) {
  Vue.component(VAvatar.name, VAvatar)
}

export default VAvatar



// WEBPACK FOOTER //
// ./src/components/VAvatar/index.js